import { useParams } from "react-router-dom";
import type { CheckDetailKind } from "./RequestDetail/checkDetailKind";
import { RequestDetailPage } from "./RequestDetail/RequestDetailPage";

export const RequestDetail = ({ kind = "site" }: { kind?: CheckDetailKind }) => {
  const { id } = useParams<{ id: string }>();
  if (!id) return null;
  return <RequestDetailPage key={`${kind}-${id}`} requestId={id} kind={kind} />;
};
